import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { CandidateModel } from "@/modules/candidate/models/candidateModel"
import { UserModel } from "@/modules/users/models/userModel"

import { ContractStatus } from "../constants/contractStatus"
import { ServiceType } from "@/modules/tasks/active/constants/serviceType"
import { EngagementType } from "@/modules/tasks/active/constants/engagementType"
import { CompanyListModel } from "@/modules/company/models/companyListModel"

export interface ContractBaseData<TStatus extends number = ContractStatus> {
  uid: string
  assignmentId: string
  /**
   * The Talent uid. Set for v1 and v2 alike; `assignmentId` is "" for a v2
   * consultant contract, so pick whichever is populated to know what to link to.
   */
  consultantId?: string
  taskId?: string
  name: string
  status: TStatus
  startDate: string
  endDate: string
  country: string
  serviceType?: ServiceType
  requester?: UserModel
  candidate?: CandidateModel
  primaryContact?: UserModel
  engagementType?: EngagementType
  entity?: CompanyListModel | null
  cost?: number
  currency?: string
  localCost?: number
  localCurrency?: string
}

@Serializable
export class ContractBaseModel<TStatus extends number = ContractStatus> {
  uid: string = ""
  assignmentId: string = ""
  consultantId: string = ""
  taskId: string = ""
  name: string = ""
  status: TStatus = ContractStatus.Pending as TStatus
  startDate: string = ""
  endDate: string = ""
  country: string = ""
  serviceType: ServiceType = ServiceType.Consultant
  requester: UserModel = new UserModel()
  candidate: CandidateModel = new CandidateModel()
  primaryContact: UserModel = new UserModel()
  engagementType: EngagementType = EngagementType.TimeAndMaterial
  entity: CompanyListModel | null = null
  cost: number = 0
  currency: string = ""
  localCost: number = 0
  localCurrency: string = ""
  constructor(data: ContractBaseData<TStatus> | null = null) {
    if (data) {
      this.uid = data.uid
      this.assignmentId = data.assignmentId
      this.consultantId = data.consultantId ?? ""
      this.taskId = data.taskId ?? ""
      this.name = data.name
      this.status = data.status
      this.startDate = data.startDate
      this.endDate = data.endDate
      this.country = data.country
      this.serviceType = data.serviceType ?? ServiceType.Consultant
      this.requester = data.requester ?? new UserModel()
      this.candidate = data.candidate ?? new CandidateModel()
      this.primaryContact = data.primaryContact ?? new UserModel()
      this.engagementType =
        data.engagementType ?? EngagementType.TimeAndMaterial
      this.entity = data.entity ? new CompanyListModel(data.entity) : null
      this.cost = data.cost ?? 0
      this.currency = data.currency ?? ""
      this.localCost = data.localCost ?? 0
      this.localCurrency = data.localCurrency ?? ""
    }
  }
}
